// // import React, { useState, useEffect } from 'react';
// // import { Link, useLocation } from 'react-router-dom';
// // import { Building2, Menu, X } from 'lucide-react';

// // const Header = () => {
// //   const [scrolled, setScrolled] = useState(false);
// //   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
// //   const location = useLocation();

// //   useEffect(() => {
// //     const handleScroll = () => {
// //       setScrolled(window.scrollY > 50);
// //     };
// //     window.addEventListener('scroll', handleScroll);
// //     return () => window.removeEventListener('scroll', handleScroll);
// //   }, []);

// //   const isActive = (path) => {
// //     return location.pathname === path;
// //   };

// //   return (
// //     <header 
// //       className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
// //         scrolled 
// //           ? 'bg-white shadow-lg py-4' 
// //           : 'bg-white/95 backdrop-blur-sm py-6'
// //       }`}
// //     >
// //       <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
// //         {/* Logo */}
// //         <Link to="/" className="flex items-center space-x-3 group">
// //           <div className="bg-black text-white p-2 rounded group-hover:bg-gray-800 transition-colors duration-300">
// //             <Building2 className="w-6 h-6" />
// //           </div>
// //           <span className="text-2xl font-bold text-gray-900">Vedamsa</span>
// //         </Link>

// //         {/* Desktop Navigation */}
// //         <nav className="hidden md:flex items-center space-x-8">
// //           <Link 
// //             to="/" 
// //             className={`transition-colors duration-300 font-medium ${
// //               isActive('/') 
// //                 ? 'text-gray-900 font-bold' 
// //                 : 'text-gray-700 hover:text-gray-900'
// //             }`}
// //           >
// //             Home
// //           </Link>
// //           <Link 
// //             to="/about" 
// //             className={`transition-colors duration-300 font-medium ${
// //               isActive('/about') 
// //                 ? 'text-gray-900 font-bold' 
// //                 : 'text-gray-700 hover:text-gray-900'
// //             }`}
// //           >
// //             About
// //           </Link>
// //           <Link 
// //             to="/contact" 
// //             className={`transition-colors duration-300 font-medium ${
// //               isActive('/contact') 
// //                 ? 'text-gray-900 font-bold' 
// //                 : 'text-gray-700 hover:text-gray-900'
// //             }`}
// //           >
// //             Contact
// //           </Link>
// //         </nav>

// //         {/* CTA Buttons */}
// //         <div className="hidden md:flex items-center space-x-4">
// //           <Link 
// //             to="/contact"
// //             className="bg-[#3d2817] text-white px-6 py-2.5 rounded-lg font-medium hover:bg-[#2d1f10] transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
// //           >
// //             Get Started
// //           </Link>
// //         </div>

// //         {/* Mobile Menu Button */}
// //         <button
// //           onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
// //           className="md:hidden text-gray-900 p-2 hover:bg-gray-100 rounded-lg transition-colors duration-300"
// //         >
// //           {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
// //         </button>
// //       </div>

// //       {/* Mobile Menu */}
// //       {mobileMenuOpen && (
// //         <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
// //           <nav className="flex flex-col px-6 py-4 space-y-4">
// //             <Link 
// //               to="/" 
// //               onClick={() => setMobileMenuOpen(false)}
// //               className={`py-2 transition-colors duration-300 font-medium ${
// //                 isActive('/') 
// //                   ? 'text-gray-900 font-bold' 
// //                   : 'text-gray-700 hover:text-gray-900'
// //               }`}
// //             >
// //               Home
// //             </Link>
// //             <Link 
// //               to="/about" 
// //               onClick={() => setMobileMenuOpen(false)}
// //               className={`py-2 transition-colors duration-300 font-medium ${
// //                 isActive('/about') 
// //                   ? 'text-gray-900 font-bold' 
// //                   : 'text-gray-700 hover:text-gray-900'
// //               }`}
// //             >
// //               About
// //             </Link>
// //             <Link 
// //               to="/contact" 
// //               onClick={() => setMobileMenuOpen(false)}
// //               className={`py-2 transition-colors duration-300 font-medium ${
// //                 isActive('/contact') 
// //                   ? 'text-gray-900 font-bold' 
// //                   : 'text-gray-700 hover:text-gray-900'
// //               }`}
// //             >
// //               Contact
// //             </Link>
// //             <Link 
// //               to="/contact"
// //               onClick={() => setMobileMenuOpen(false)}
// //               className="bg-[#3d2817] text-white px-6 py-3 rounded-lg font-medium hover:bg-[#2d1f10] transition-all duration-300 text-center"
// //             >
// //               Get Started
// //             </Link>
// //           </nav>
// //         </div>
// //       )}
// //     </header>
// //   );
// // };

// // export default Header;


// import React, { useState, useEffect, useRef } from 'react';
// import { Link, useLocation } from 'react-router-dom';
// import { Building2, Menu, X, ChevronDown } from 'lucide-react';

// const Header = () => {
//   const [scrolled, setScrolled] = useState(false);
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const [projectsDropdownOpen, setProjectsDropdownOpen] = useState(false);
//   const dropdownRef = useRef(null);
//   const location = useLocation();

//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 50);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const isActive = (path) => {
//     return location.pathname === path;
//   };

//   const isProjectsActive = () => {
//     return location.pathname === '/maa-srinivasam' || location.pathname === '/maa-garudadri';
//   };

//   const handleMouseEnter = () => {
//     setProjectsDropdownOpen(true);
//   };

//   const handleMouseLeave = () => {
//     setProjectsDropdownOpen(false);
//   };

//   return (
//     <header 
//       className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
//         scrolled 
//           ? 'bg-white shadow-lg py-4' 
//           : 'bg-white/95 backdrop-blur-sm py-6'
//       }`}
//     >
//       <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
//         {/* Logo */}
//         <Link to="/" className="flex items-center space-x-3 group">
//           <div className="bg-black text-white p-2 rounded group-hover:bg-gray-800 transition-colors duration-300">
//             <Building2 className="w-6 h-6" />
//           </div>
//           <span className="text-2xl font-bold text-gray-900">Vedamsa</span>
//         </Link>

//         {/* Desktop Navigation */}
//         <nav className="hidden md:flex items-center space-x-8">
//           <Link 
//             to="/" 
//             className={`transition-colors duration-300 font-medium ${
//               isActive('/') 
//                 ? 'text-gray-900 font-bold' 
//                 : 'text-gray-700 hover:text-gray-900'
//             }`}
//           >
//             Home
//           </Link>

//           {/* Projects Dropdown */}
//           <div 
//             ref={dropdownRef}
//             className="relative"
//             onMouseEnter={handleMouseEnter}
//             onMouseLeave={handleMouseLeave}
//           >
//             <button 
//               className={`flex items-center space-x-1 transition-colors duration-300 font-medium ${
//                 isProjectsActive() 
//                   ? 'text-gray-900 font-bold' 
//                   : 'text-gray-700 hover:text-gray-900'
//               }`}
//             >
//               <span>Projects</span>
//               <ChevronDown className={`w-4 h-4 transition-transform duration-300 ${projectsDropdownOpen ? 'rotate-180' : ''}`} />
//             </button>

//             {/* Dropdown Menu */}
//             <div 
//               className={`absolute top-full left-0 mt-2 w-64 bg-white rounded-lg shadow-xl border border-gray-100 py-2 transition-all duration-200 ${
//                 projectsDropdownOpen 
//                   ? 'opacity-100 visible translate-y-0' 
//                   : 'opacity-0 invisible -translate-y-2 pointer-events-none'
//               }`}
//             >
//               <Link 
//                 to="/Projects/srinivas"
//                 className="block px-4 py-3 hover:bg-gray-50 transition-colors duration-200"
//                 onClick={() => setProjectsDropdownOpen(false)}
//               >
//                 <div className="font-semibold text-gray-900">MAA Srinivasam</div>
//                 <div className="text-sm text-gray-600">2 & 3 BHK Luxury Apartments</div>
//               </Link>
//               <div className="border-t border-gray-100"></div>
//               <Link 
//                 to="/Projects/garudadri"
//                 className="block px-4 py-3 hover:bg-gray-50 transition-colors duration-200"
//                 onClick={() => setProjectsDropdownOpen(false)}
//               >
//                 <div className="font-semibold text-gray-900">MAA Garudadri</div>
//                 <div className="text-sm text-gray-600">Premium Villa Plots</div>
//               </Link>
//             </div>
//           </div>

//           <Link 
//             to="/about" 
//             className={`transition-colors duration-300 font-medium ${
//               isActive('/about') 
//                 ? 'text-gray-900 font-bold' 
//                 : 'text-gray-700 hover:text-gray-900'
//             }`}
//           >
//             About
//           </Link>
//           <Link 
//             to="/contact" 
//             className={`transition-colors duration-300 font-medium ${
//               isActive('/contact') 
//                 ? 'text-gray-900 font-bold' 
//                 : 'text-gray-700 hover:text-gray-900'
//             }`}
//           >
//             Contact
//           </Link>
//         </nav>

//         {/* CTA Buttons */}
//         <div className="hidden md:flex items-center space-x-4">
//           <Link 
//             to="/contact"
//             className="bg-[#3d2817] text-white px-6 py-2.5 rounded-lg font-medium hover:bg-[#2d1f10] transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
//           >
//             Get Started
//           </Link>
//         </div>

//         {/* Mobile Menu Button */}
//         <button
//           onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//           className="md:hidden text-gray-900 p-2 hover:bg-gray-100 rounded-lg transition-colors duration-300"
//         >
//           {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
//         </button>
//       </div>

//       {/* Mobile Menu */}
//       {mobileMenuOpen && (
//         <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
//           <nav className="flex flex-col px-6 py-4 space-y-4">
//             <Link 
//               to="/" 
//               onClick={() => setMobileMenuOpen(false)}
//               className={`py-2 transition-colors duration-300 font-medium ${
//                 isActive('/') 
//                   ? 'text-gray-900 font-bold' 
//                   : 'text-gray-700 hover:text-gray-900'
//               }`}
//             >
//               Home
//             </Link>

//             {/* Mobile Projects Submenu */}
//             <div className="py-2">
//               <div className="font-medium text-gray-900 mb-2">Projects</div>
//               <div className="pl-4 space-y-3">
//                 <Link 
//                   to="/maa-srinivasam"
//                   onClick={() => setMobileMenuOpen(false)}
//                   className="block py-2 text-gray-700 hover:text-gray-900 transition-colors duration-300"
//                 >
//                   <div className="font-semibold">MAA Srinivasam</div>
//                   <div className="text-sm text-gray-600">2 & 3 BHK Apartments</div>
//                 </Link>
//                 <Link 
//                   to="/maa-garudadri"
//                   onClick={() => setMobileMenuOpen(false)}
//                   className="block py-2 text-gray-700 hover:text-gray-900 transition-colors duration-300"
//                 >
//                   <div className="font-semibold">MAA Garudadri</div>
//                   <div className="text-sm text-gray-600">Villa Plots</div>
//                 </Link>
//               </div>
//             </div>

//             <Link 
//               to="/about" 
//               onClick={() => setMobileMenuOpen(false)}
//               className={`py-2 transition-colors duration-300 font-medium ${
//                 isActive('/about') 
//                   ? 'text-gray-900 font-bold' 
//                   : 'text-gray-700 hover:text-gray-900'
//               }`}
//             >
//               About
//             </Link>
//             <Link 
//               to="/contact" 
//               onClick={() => setMobileMenuOpen(false)}
//               className={`py-2 transition-colors duration-300 font-medium ${
//                 isActive('/contact') 
//                   ? 'text-gray-900 font-bold' 
//                   : 'text-gray-700 hover:text-gray-900'
//               }`}
//             >
//               Contact
//             </Link>
//             <Link 
//               to="/contact"
//               onClick={() => setMobileMenuOpen(false)}
//               className="bg-[#3d2817] text-white px-6 py-3 rounded-lg font-medium hover:bg-[#2d1f10] transition-all duration-300 text-center"
//             >
//               Get Started
//             </Link>
//           </nav>
//         </div>
//       )}
//     </header>
//   );
// };

// export default Header;
import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Building2, Menu, X, ChevronDown } from 'lucide-react';
import logo from './Images/vedamsa_logo_transparent.png';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [projectsDropdownOpen, setProjectsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const dropdownTimerRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Cleanup timer on unmount
  useEffect(() => {
    return () => {
      if (dropdownTimerRef.current) {
        clearTimeout(dropdownTimerRef.current);
      }
    };
  }, []);

  const isActive = (path) => {
    return location.pathname === path;
  };

  const isProjectsActive = () => {
    return location.pathname === '/maa-srinivasam' || location.pathname === '/maa-garudadri';
  };

  const handleMouseEnter = () => {
    // Clear any existing timer
    if (dropdownTimerRef.current) {
      clearTimeout(dropdownTimerRef.current);
    }
    setProjectsDropdownOpen(true);
  };

  const handleMouseLeave = () => {
    // Set timer to close dropdown after 30 seconds
    dropdownTimerRef.current = setTimeout(() => {
      setProjectsDropdownOpen(false);
    }, 3000); // 30 seconds
  };

  const handleDropdownClick = () => {
    // Close immediately when user clicks a link
    if (dropdownTimerRef.current) {
      clearTimeout(dropdownTimerRef.current);
    }
    setProjectsDropdownOpen(false);
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled 
          ? 'bg-white shadow-lg py-4' 
          : 'bg-white/95 backdrop-blur-sm py-6'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo - Replace with your logo image */}
  <Link to="/" className="flex items-center group">
  <img 
    src={logo}
    alt="Vedamsa Logo" 
    className="h-16 md:h-20 w-auto object-contain group-hover:opacity-90 transition-all duration-300"
  />
</Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8">
          <Link 
            to="/" 
            className={`transition-colors duration-300 font-medium ${
              isActive('/') 
                ? 'text-gray-900 font-bold' 
                : 'text-gray-700 hover:text-gray-900'
            }`}
          >
            Home
          </Link>

          {/* Projects Dropdown */}
          <div 
            ref={dropdownRef}
            className="relative"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <button 
              className={`flex items-center space-x-1 transition-colors duration-300 font-medium ${
                isProjectsActive() 
                  ? 'text-gray-900 font-bold' 
                  : 'text-gray-700 hover:text-gray-900'
              }`}
            >
              <span>Projects</span>
              <ChevronDown className={`w-4 h-4 transition-transform duration-300 ${projectsDropdownOpen ? 'rotate-180' : ''}`} />
            </button>

            {/* Dropdown Menu */}
            <div 
              className={`absolute top-full left-0 mt-2 w-64 bg-white rounded-lg shadow-xl border border-gray-100 py-2 transition-all duration-200 ${
                projectsDropdownOpen 
                  ? 'opacity-100 visible translate-y-0' 
                  : 'opacity-0 invisible -translate-y-2 pointer-events-none'
              }`}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <Link 
                to="/Projects/srinivas"
                className="block px-4 py-3 hover:bg-gray-50 transition-colors duration-200"
                onClick={handleDropdownClick}
              >
                <div className="font-semibold text-gray-900">MAA Srinivasam</div>
                <div className="text-sm text-gray-600">2 & 3 BHK Luxury Apartments</div>
              </Link>
              <div className="border-t border-gray-100"></div>
              <Link 
                to="/Projects/garudadri"
                className="block px-4 py-3 hover:bg-gray-50 transition-colors duration-200"
                onClick={handleDropdownClick}
              >
                <div className="font-semibold text-gray-900">MAA Garudadri</div>
                <div className="text-sm text-gray-600">Premium Villa Plots</div>
              </Link>
            </div>
          </div>

          <Link 
            to="/about" 
            className={`transition-colors duration-300 font-medium ${
              isActive('/about') 
                ? 'text-gray-900 font-bold' 
                : 'text-gray-700 hover:text-gray-900'
            }`}
          >
            About
          </Link>
          <Link 
            to="/contact" 
            className={`transition-colors duration-300 font-medium ${
              isActive('/contact') 
                ? 'text-gray-900 font-bold' 
                : 'text-gray-700 hover:text-gray-900'
            }`}
          >
            Contact
          </Link>
        </nav>

        {/* CTA Buttons */}
        <div className="hidden md:flex items-center space-x-4">
          <Link 
            to="/contact"
            className="bg-[#3d2817] text-white px-6 py-2.5 rounded-lg font-medium hover:bg-[#2d1f10] transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
          >
            Get Started
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="md:hidden text-gray-900 p-2 hover:bg-gray-100 rounded-lg transition-colors duration-300"
        >
          {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
          <nav className="flex flex-col px-6 py-4 space-y-4">
            <Link 
              to="/" 
              onClick={() => setMobileMenuOpen(false)}
              className={`py-2 transition-colors duration-300 font-medium ${
                isActive('/') 
                  ? 'text-gray-900 font-bold' 
                  : 'text-gray-700 hover:text-gray-900'
              }`}
            >
              Home
            </Link>

            {/* Mobile Projects Submenu */}
            <div className="py-2">
              <div className="font-medium text-gray-900 mb-2">Projects</div>
              <div className="pl-4 space-y-3">
                <Link 
                  to="/Projects/srinivas"
                  onClick={() => setMobileMenuOpen(false)}
                  className="block py-2 text-gray-700 hover:text-gray-900 transition-colors duration-300"
                >
                  <div className="font-semibold">MAA Srinivasam</div>
                  <div className="text-sm text-gray-600">2 & 3 BHK Apartments</div>
                </Link>
                <Link 
                  to="/Projects/garudadri"
                  onClick={() => setMobileMenuOpen(false)}
                  className="block py-2 text-gray-700 hover:text-gray-900 transition-colors duration-300"
                >
                  <div className="font-semibold">MAA Garudadri</div>
                  <div className="text-sm text-gray-600">Villa Plots</div>
                </Link>
              </div>
            </div>

            <Link 
              to="/about" 
              onClick={() => setMobileMenuOpen(false)}
              className={`py-2 transition-colors duration-300 font-medium ${
                isActive('/about') 
                  ? 'text-gray-900 font-bold' 
                  : 'text-gray-700 hover:text-gray-900'
              }`}
            >
              About
            </Link>
            <Link 
              to="/contact" 
              onClick={() => setMobileMenuOpen(false)}
              className={`py-2 transition-colors duration-300 font-medium ${
                isActive('/contact') 
                  ? 'text-gray-900 font-bold' 
                  : 'text-gray-700 hover:text-gray-900'
              }`}
            >
              Contact
            </Link>
            <Link 
              to="/contact"
              onClick={() => setMobileMenuOpen(false)}
              className="bg-[#3d2817] text-white px-6 py-3 rounded-lg font-medium hover:bg-[#2d1f10] transition-all duration-300 text-center"
            >
              Get Started
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;